/**
 * System-wide default values
 */
export const systemDefaultValues = Object.freeze({
    country: "AU",
    currency: "AUD",
    locale: "en-AU",
    timezone: "Australia/Sydney",
    invoiceDueDateOffset: 30,
});
/**
 * Enum of user types for type safety
 */
export var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["ADMIN"] = "admin";
    USER_TYPE["MANAGER"] = "manager";
    USER_TYPE["EXTERNAL_USER"] = "ext-user";
})(USER_TYPE || (USER_TYPE = {}));
export const SYSTEM_OPERATION = {
    BOOKING_CREATION: "booking-creation",
    ADD_ON_CHARGE: "add-on-charge",
};
export const ENQUEUE_SNACKBAR_AUTOHIDE_DURATION = 1000; // 1 second
export const FILE_SIZE_MAX_BYTES = 30 * 1024 * 1024; // 30MiB
export const FILE_SIZE_MAX_WARNING = "File size must be less than 30MB";
export var GST_REGISTRATION_STATUS;
(function (GST_REGISTRATION_STATUS) {
    GST_REGISTRATION_STATUS["REGISTERED"] = "REGISTERED";
    GST_REGISTRATION_STATUS["NOT_REGISTERED"] = "NOT_REGISTERED";
})(GST_REGISTRATION_STATUS || (GST_REGISTRATION_STATUS = {}));
export const GST_REGISTRATION_STATUS_OPTIONS = {
    [GST_REGISTRATION_STATUS.REGISTERED]: {
        id: GST_REGISTRATION_STATUS.REGISTERED,
        label: "Registered",
    },
    [GST_REGISTRATION_STATUS.NOT_REGISTERED]: {
        id: GST_REGISTRATION_STATUS.NOT_REGISTERED,
        label: "Not Registered",
    },
};
export const BULK_IMPORT_MAX_TOTAL_BYTES = 1024 * 1024 * 1024; // 1GiB
export const BULK_IMPORT_MAX_TOTAL_WARNING = "Total upload size must be less than 1GB. Split your documents across multiple imports.";
//# sourceMappingURL=system.js.map